var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "max-width": "500"
    },
    model: {
      value: _vm.dialog,
      callback: function callback($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v(" 메인 상품 변경 ")]), _c('v-card-text', [_c('v-btn', {
    staticClass: "primary--text px-2 ml-1",
    attrs: {
      "color": "white"
    },
    on: {
      "click": function click($event) {
        return _vm.update(true);
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("mdi-microsoft-excel")]), _vm._v("메인 상품 등록 ")], 1), _c('v-btn', {
    staticClass: "primary--text px-2 ml-1",
    attrs: {
      "color": "white"
    },
    on: {
      "click": function click($event) {
        return _vm.update(false);
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("mdi-microsoft-excel")]), _vm._v("메인 상품 해제 ")], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }